module.exports = __webpack_public_path__ + "img/img_thermo_2.c83bd631.png";